
import { ReactNode } from 'react';
import { cn } from '@/lib/utils';

interface PrayerFormStepNavProps {
  onPrevious: () => void;
  previousDisabled?: boolean;
  children: ReactNode;
}

export function PrayerFormStepNav({
  onPrevious,
  previousDisabled = false,
  children,
}: PrayerFormStepNavProps) {
  return (
    <div className="flex flex-col gap-6 pt-4">
      <div className="flex items-center gap-4">
        <button
          type="button"
          onClick={onPrevious}
          disabled={previousDisabled}
          className={cn(
            'shrink-0 text-sm text-slate-500 hover:text-slate-800 dark:text-slate-400 dark:hover:text-slate-200',
            'disabled:opacity-40 disabled:cursor-not-allowed transition-colors'
          )}
        >
          ← Previous
        </button>
        <div className="flex-1 min-w-0">{children}</div>
      </div>
    </div>
  );
}
